<!-- Content Wrapper Start -->
<div class="fm-content-wrapper">
  <div class="fm-rs-steps">
    <!-- Page Title Start -->
    <div class="fm-page-title">
      <h2 class="fm-head-24 fm-title">Schedule a Memory Prompt</h2>
    </div>
    <!-- Page Title End -->

    <!-- Step Form Start -->
    <div class="fm-rs-step-form fm-schedule-prompt-form">
      <!-- STEP HEADER -->
      <div class="fm-step-wrapper">
        <div class="fm-white-column">
          <div class="fm-step-list">
            <div
              class="fm-step-item"
              [class.active]="currentStep() >= 1"
              [class.completed]="currentStep() > 1"
              (click)="currentStep() > 1 && goToStep(1)"
              role="button"
              tabindex="0"
              aria-label="Step 1"
            >
              <div class="fm-step-icon">
                <img class="fm-svg" src="images/icons/fm-step1-icon.svg" alt="Step 1" />
              </div>
              <div class="fm-step-number">Step 01</div>
              <div class="fm-step-title">Choose Category</div>
            </div>
            <div
              class="fm-step-item"
              [class.active]="currentStep() >= 2"
              [class.completed]="currentStep() > 2"
              (click)="currentStep() > 2 && goToStep(2)"
              role="button"
              tabindex="0"
              aria-label="Step 2"
            >
              <div class="fm-step-icon">
                <img class="fm-svg" src="images/icons/fm-step2-icon.svg" alt="Step 2" />
              </div>
              <div class="fm-step-number">Step 02</div>
              <div class="fm-step-title">Select Media Type</div>
            </div>
            <div
              class="fm-step-item"
              [class.active]="currentStep() >= 3"
              [class.completed]="currentStep() > 3"
              (click)="currentStep() > 3 && goToStep(3)"
              role="button"
              tabindex="0"
              aria-label="Step 3"
            >
              <div class="fm-step-icon">
                <img class="fm-svg" src="images/icons/fm-step3-icon.svg" alt="Step 3" />
              </div>
              <div class="fm-step-number">Step 03</div>
              <div class="fm-step-title">Select Questions</div>
            </div>
            <div
              class="fm-step-item"
              [class.active]="currentStep() >= 4"
              role="button"
              tabindex="0"
              aria-label="Step 4"
            >
              <div class="fm-step-icon">
                <img class="fm-svg" src="images/icons/fm-step4-icon_promt.svg" alt="Step 4" />
              </div>
              <div class="fm-step-number">Step 04</div>
              <div class="fm-step-title">Send to</div>
            </div>
          </div>
        </div>
      </div>

      <!-- ============================================================ -->
      <!-- STEP 1: Choose Category                                       -->
      <!-- ============================================================ -->
      @if (currentStep() === 1) {
        <div class="fm-step-content active">
          <div class="fm-card-wrapper">
            <div class="fm-white-column">
              <div class="fm-section-title">
                <h2 class="fm-head-24">What memory would you like to ask about?</h2>
                <p>Choose a category to get started with AI-powered prompts</p>
              </div>
              @if (loadingCategories()) {
                <div class="fm-category-grid fm-skeleton-grid">
                  @for (_ of [1, 2, 3, 4, 5, 6, 7, 8]; track $index) {
                    <div class="fm-skeleton-category-card">
                      <div class="fm-skeleton-icon"></div>
                      <div class="fm-skeleton-line fm-skeleton-line--title"></div>
                      <div class="fm-skeleton-line fm-skeleton-line--sub"></div>
                    </div>
                  }
                </div>
              } @else {
                <div class="fm-category-grid">
                  @for (cat of apiCategories(); track cat.categoryId) {
                    <div class="fm-category-box">
                      <input
                        type="radio"
                        name="memory"
                        [id]="'cat-' + cat.categoryId"
                        [checked]="selectedCategory() === cat.categoryId"
                        (change)="selectCategory(cat.categoryId)"
                      />
                      <label class="fm-category-label" [for]="'cat-' + cat.categoryId">
                        <div class="fm-check-icon">
                          <img src="images/icons/fm-check.svg" class="fm-svg" alt="Selected" />
                        </div>
                        <div class="fm-category-icon">
                          <img
                            [src]="getCategoryIcon(cat)"
                            class="fm-svg"
                            [alt]="cat.categoryName"
                          />
                        </div>
                        <h4 class="fm-head-22">{{ cat.categoryName }}</h4>
                        <p>{{ cat.totalPrompt }} prompts available</p>
                      </label>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="fm-form-footer">
            <button
              type="button"
              class="fm-common-btn fm-border-btn fm-white-btn fm-btn-cancel"
              (click)="cancelSchedule()"
            >
              Cancel
            </button>
            <button type="button" class="fm-common-btn fm-btn-next" (click)="nextStep()">
              Continue
              <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Next" />
            </button>
          </div>
        </div>
      }

      <!-- ============================================================ -->
      <!-- STEP 2: Select Media Type                                     -->
      <!-- ============================================================ -->
      @if (currentStep() === 2) {
        <div class="fm-step-content active">
          <div class="fm-card-wrapper">
            <div class="fm-white-column">
              <div class="fm-compressed-cl">
                <div class="fm-section-title">
                  <h2 class="fm-head-24">How should they answer?</h2>
                  <p>
                    Choose how your loved one will share their {{ selectedCategoryName() }} memories
                  </p>
                </div>
                <div class="fm-media-list">
                  @for (media of mediaTypes; track media.id) {
                    <div
                      class="fm-media-card"
                      [class.active]="selectedMedia() === media.id"
                      (click)="selectMedia(media.id)"
                      role="button"
                      tabindex="0"
                    >
                      <div class="fm-media-left">
                        <div class="fm-media-icon">
                          <img [src]="media.icon" class="fm-svg" [alt]="media.label" />
                        </div>
                        <div>
                          <h4 class="fm-head-22">{{ media.label }}</h4>
                          <p>{{ media.description }}</p>
                        </div>
                      </div>
                      <div class="fm-check-icon">
                        <img src="images/icons/fm-check.svg" class="fm-svg" alt="Selected" />
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="fm-compressed-cl">
            <div class="fm-form-footer fm-space-between">
              <button
                type="button"
                class="fm-common-btn fm-border-btn fm-white-btn fm-btn-cancel"
                (click)="prevStep()"
              >
                <img src="images/icons/fm-arrow-left.svg" class="fm-svg" alt="Back" />
                Back
              </button>
              <button type="button" class="fm-common-btn fm-btn-next" (click)="nextStep()">
                Continue
                <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Next" />
              </button>
            </div>
          </div>
        </div>
      }

      <!-- ============================================================ -->
      <!-- STEP 3: Select Questions                                      -->
      <!-- ============================================================ -->
      @if (currentStep() === 3) {
        <div class="fm-step-content active">
          <div class="fm-card-wrapper">
            <div class="fm-white-column">
              <div class="fm-compressed-cl fm-large-cl">
                <div class="fm-section-title">
                  <h2 class="fm-head-24">Select Questions</h2>
                  <p>Choose which questions to send to your loved one</p>
                </div>
                @if (showQuestionError()) {
                  <div class="fm-alert fm-alert-danger" role="alert">
                    <div class="fm-alert-icon">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z"
                          fill="#DC3545"
                        />
                      </svg>
                    </div>
                    <div class="fm-alert-content">
                      <strong>{{ questionErrorMessage() }}</strong>
                    </div>
                    <button
                      type="button"
                      class="fm-alert-close"
                      (click)="showQuestionError.set(false)"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                }

                <div class="fm-questions-header mb-2">
                  <span
                    class="fm-selected-count"
                    [class.has-error]="showQuestionError() && selectedQuestions().length === 0"
                  >
                    {{ selectedQuestions().length }} of {{ questions().length }} selected
                  </span>
                  <div class="fm-select-actions">
                    <button type="button" class="fm-link-btn" (click)="selectAllQuestions()">
                      Select All
                    </button>
                    <span class="fm-divider">&nbsp;|&nbsp;</span>
                    <button type="button" class="fm-link-btn" (click)="clearAllQuestions()">
                      Clear All
                    </button>
                  </div>
                </div>

                @if (loadingPrompts()) {
                  <div class="fm-question-list fm-skeleton-question-list">
                    @for (_ of [1, 2, 3, 4, 5]; track $index) {
                      <div class="fm-skeleton-question-card">
                        <div class="fm-skeleton-num"></div>
                        <div class="fm-skeleton-line fm-skeleton-line--q"></div>
                      </div>
                    }
                  </div>
                } @else {
                  <div class="fm-question-list">
                    @for (q of questions(); track q.id; let i = $index) {
                      <div
                        class="fm-question-card"
                        [class.active]="q.selected"
                        [class.fm-question-custom]="q.isCustom"
                        (click)="editingQuestionId() !== q.id && toggleQuestion(q.id)"
                        role="checkbox"
                        [attr.aria-checked]="q.selected"
                        tabindex="0"
                        (keydown.enter)="editingQuestionId() !== q.id && toggleQuestion(q.id)"
                        (keydown.space)="onQuestionCardSpace($event, q.id)"
                      >
                        <span class="fm-question-number">{{
                          (i + 1).toString().padStart(2, '0')
                        }}</span>

                        @if (editingQuestionId() === q.id) {
                          <div class="fm-inline-edit" (click)="$event.stopPropagation()">
                            <input
                              type="text"
                              class="form-control fm-inline-edit-input"
                              maxlength="100"
                              [value]="editingQuestionText()"
                              (input)="editingQuestionText.set($any($event.target).value)"
                              (keydown.enter)="saveEditQuestion()"
                              (keydown.escape)="cancelEditQuestion()"
                            />
                            <button
                              type="button"
                              class="btn fm-icon-btn fm-icon-btn-save"
                              [disabled]="savingEditQuestion()"
                              (click)="saveEditQuestion()"
                              title="Save"
                            >
                              <img src="images/icons/fm-check.svg" class="fm-svg" alt="Save" />
                            </button>
                            <button
                              type="button"
                              class="btn fm-icon-btn"
                              (click)="cancelEditQuestion()"
                              title="Cancel"
                            >
                              <img src="images/icons/fm-bl-x.svg" class="fm-svg" alt="Cancel" />
                            </button>
                          </div>
                        } @else {
                          <p class="mb-0 fm-question-text">{{ q.text }}</p>
                        }

                        @if (q.isCustom && editingQuestionId() !== q.id) {
                          <div
                            class="fm-question-actions fm-dropdown"
                            (click)="$event.stopPropagation()"
                          >
                            <button
                              type="button"
                              class="fm-question-menu-btn"
                              (click)="toggleQuestionMenu(q.id, $event)"
                              aria-label="Open question actions"
                            >
                              <img
                                src="images/icons/fm-vertical-dots.svg"
                                class="fm-svg"
                                alt="Actions"
                              />
                            </button>
                            @if (openMenuId() === q.id) {
                              <div class="dropdown-menu fm-dropdown-menu show">
                                <button
                                  type="button"
                                  class="dropdown-item fm-dropdown-item"
                                  (click)="startEditQuestion(q.id)"
                                >
                                  <img src="images/icons/fm-edit.svg" class="fm-svg" alt="Edit" />
                                  <span class="fm-question-action-label">Edit</span>
                                </button>
                                <button
                                  type="button"
                                  class="dropdown-item fm-dropdown-item fm-question-delete-btn"
                                  (click)="deleteQuestion(q.id)"
                                >
                                  <img
                                    src="images/icons/fm-delete.svg"
                                    class="fm-svg"
                                    alt="Delete"
                                  />
                                  <span class="fm-question-action-label">Delete</span>
                                </button>
                              </div>
                            }
                          </div>
                        }

                        <div class="fm-check-icon" aria-hidden="true">
                          <img src="images/icons/fm-check-white.svg" class="fm-svg" alt="" />
                        </div>
                      </div>
                    }
                  </div>
                }

                <!-- Add Custom Question -->
                <div class="fm-add-question-btn">
                  <button type="button" class="fm-common-btn" (click)="toggleCustomQuestion()">
                    <img src="images/icons/fm-plus-large.svg" class="fm-svg" alt="Add" />
                    Add Your Own Questions
                  </button>
                </div>
                @if (showCustomQuestion()) {
                  <div class="fm-custom-question">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Type your question..."
                        maxlength="100"
                        [value]="customQuestionText()"
                        (input)="customQuestionText.set($any($event.target).value)"
                      />
                      <button
                        type="button"
                        class="btn fm-icon-btn"
                        [disabled]="savingCustomQuestion()"
                        (click)="saveCustomQuestion()"
                        aria-label="Save question"
                      >
                        <img src="images/icons/fm-bookmark.svg" class="fm-svg" alt="Save" />
                      </button>
                      <button
                        type="button"
                        class="btn fm-icon-btn"
                        (click)="toggleCustomQuestion()"
                        aria-label="Cancel"
                      >
                        <img src="images/icons/fm-trash.svg" class="fm-svg" alt="Cancel" />
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="fm-compressed-cl fm-large-cl">
            @if (showQuestionError() && selectedQuestions().length === 0) {
              <div class="fm-validation-warning">
                <div class="fm-validation-icon">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <circle cx="8" cy="8" r="7" stroke="#DC3545" stroke-width="1.5" />
                    <path
                      d="M8 4V9M8 11H8.01"
                      stroke="#DC3545"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <span>Please select at least one question to continue</span>
              </div>
            }

            <div class="fm-form-footer fm-space-between">
              <button
                type="button"
                class="fm-common-btn fm-border-btn fm-white-btn fm-btn-cancel"
                (click)="prevStep()"
              >
                <img src="images/icons/fm-arrow-left.svg" class="fm-svg" alt="Back" />
                Back
              </button>
              <button
                type="button"
                class="fm-common-btn fm-btn-next"
                [class.btn-disabled]="selectedQuestions().length === 0"
                title="Please select at least one question"
                (click)="nextStep()"
              >
                Continue
                <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Next" />
              </button>
            </div>
          </div>
        </div>
      }

      <!-- ============================================================ -->
      <!-- STEP 4: Send to                                               -->
      <!-- ============================================================ -->
      @if (currentStep() === 4) {
        <div class="fm-step-content active">
          <div class="fm-card-wrapper">
            <div class="fm-white-column">
              <div class="fm-schedule-prompt-card">
                <div class="fm-section-title">
                  <h2 class="fm-head-24">Who should answer?</h2>
                  <p>Select the loved one you'd like to send this memory prompt to</p>
                </div>
                <div class="fm-family-filter-inline">
                  <p class="fm-black-cl fm-icon-content mb-0 fm-family-filter-textline">
                    <img
                      src="images/icons/fm-family-group.svg"
                      class="fm-family-icon"
                      alt="Family Icon"
                    />
                    Filter by Family :
                  </p>
                  <div class="fm-filter-tags fm-filter-selected fm-family-filter-tags-line">
                    <!-- Self toggle -->
                    <button
                      type="button"
                      class="fm-filter-tag fm-filter-tag-sm"
                      [class.fm-ft-active]="selfSelected()"
                      (click)="selfSelected.set(!selfSelected())"
                    >
                      Self
                    </button>

                    <span style="color: #ccc; margin: 0 2px">|</span>
                    <button
                      type="button"
                      class="fm-filter-tag fm-filter-tag-sm"
                      [class.fm-ft-active]="selectedFamilyFilter() === 'all'"
                      (click)="selectFamilyFilter('all')"
                    >
                      All Family
                    </button>
                    @for (space of familySpaces(); track space.familySpaceId) {
                      <button
                        type="button"
                        class="fm-filter-tag fm-filter-tag-sm"
                        [class.fm-ft-active]="selectedFamilyFilter() === space.familySpaceId"
                        (click)="selectFamilyFilter(space.familySpaceId)"
                      >
                        {{ space.familyName }}
                      </button>
                    }
                  </div>
                </div>
                <div class="fm-card-group fm-filter-family fm-check-cards">
                  <div class="row g-3 g-xxl-4">
                    @for (member of filteredMembers(); track member.familyMemberId) {
                      <div class="col-12 col-sm-6 col-xxl-4">
                        <input
                          type="checkbox"
                          name="schedulePromptPeople"
                          [id]="'fmScheduleTag-' + member.familyMemberId"
                          class="fm-check-card-input"
                          [checked]="isMemberSelected(member.familyMemberId)"
                          (change)="toggleMember(member.familyMemberId)"
                        />
                        <label class="fm-card-sm" [for]="'fmScheduleTag-' + member.familyMemberId">
                          <div class="fm-check-icon">
                            <img src="images/icons/fm-check.svg" class="fm-svg" />
                          </div>
                          <div class="fm-card-img">
                            @if (member.image.trim()) {
                              <img
                                [src]="member.image"
                                [alt]="member.fullName"
                                class="fm-card-sm-image"
                                onerror="
                                  this.style.display = 'none';
                                  this.nextElementSibling.style.display = 'flex';
                                "
                              />
                              <span class="fm-card-sm-initials" style="display: none">
                                {{ getMemberInitials(member) }}
                              </span>
                            } @else {
                              <span class="fm-card-sm-initials">
                                {{ getMemberInitials(member) }}
                              </span>
                            }
                          </div>
                          <div class="fm-card-content">
                            <p class="fm-card-name">{{ member.fullName }}</p>
                            <ul>
                              <li>{{ member.relationship }}</li>
                              <li><span class="fm-dot"></span></li>
                              <li>{{ member.familyName }}</li>
                            </ul>
                          </div>
                        </label>
                      </div>
                    }
                  </div>
                  @if (filteredMembers().length === 0) {
                    <p class="fm-filter-no-data fm-black-cl mt-3 mb-0">No family members found</p>
                  }
                </div>
                @if (step4Submitted() && selectedMemberIds().size === 0 && !selfSelected()) {
                  <div class="invalid-feedback d-block mt-2">
                    At least one member must be invited.
                  </div>
                }

                <!-- Form Fields -->
                <div class="row fm-prompt-form-row">
                  <!-- Prompt Frequency -->
                  <div class="col-lg-6 mt-4">
                    <div class="fm-common-card">
                      <div class="fm-common-card-header">
                        <h5 class="fm-head-18 fm-common-card-title">Prompt Frequency</h5>
                      </div>
                      <hr class="w-100 my-3" />
                      <div class="form-group">
                        <label class="fm-label">How often should we send this memory prompt?</label>
                        <select
                          class="form-select fm-form-select"
                          [ngModel]="promptFrequency()"
                          (ngModelChange)="promptFrequency.set($event)"
                        >
                          @for (freq of frequencyTypes(); track freq.id) {
                            <option [ngValue]="freq.id">{{ freq.name }}</option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                  <!-- Questions Per Prompt -->
                  <div class="col-lg-6 mt-4">
                    <div class="fm-common-card">
                      <div class="fm-common-card-header">
                        <h5 class="fm-head-18 fm-common-card-title">Questions Per Prompt</h5>
                      </div>
                      <hr class="w-100 my-3" />
                      <div class="form-group">
                        <label class="fm-label"
                          >How many questions should be included in each prompt?</label
                        >
                        <select
                          class="form-select fm-form-select"
                          [ngModel]="questionsPerPrompt()"
                          (ngModelChange)="questionsPerPrompt.set($event)"
                        >
                          <option value="1">1 Question</option>
                          <option value="2">2 Questions</option>
                          <option value="3">3 Questions</option>
                          <option value="4">4 Questions</option>
                          <option value="5">5 Questions</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <!-- Prompt Title -->
                  <div class="col-lg-6 mt-4">
                    <div class="fm-common-card">
                      <div class="fm-common-card-header">
                        <h5 class="fm-head-18 fm-common-card-title">
                          Prompt Title <span class="fm-required">*</span>
                        </h5>
                      </div>
                      <div class="fm-common-card-body form-group mt-3">
                        <input
                          type="text"
                          class="form-control fm-form-control"
                          placeholder="Share a memory about your grandparents"
                          maxlength="250"
                          [class.is-invalid]="
                            step4Submitted() &&
                            (!promptTitle().trim() || promptTitle().length > 250)
                          "
                          [ngModel]="promptTitle()"
                          (ngModelChange)="promptTitle.set($event)"
                        />
                        <div class="d-flex justify-content-between align-items-start mt-1">
                          <div>
                            @if (step4Submitted() && !promptTitle().trim()) {
                              <div class="invalid-feedback d-block">Prompt title is required.</div>
                            }
                          </div>
                          <small
                            class="text-muted"
                            [class.text-danger]="promptTitle().length > 250"
                          >
                            {{ promptTitle().length }}/250
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Prompt Start Date -->
                  <div class="col-lg-6 mt-4">
                    <div class="fm-common-card">
                      <div class="fm-common-card-header">
                        <h5 class="fm-head-18 fm-common-card-title">
                          Start Date <span class="fm-required">*</span>
                        </h5>
                      </div>
                      <div class="fm-common-card-body form-group mt-3">
                        <div class="fm-datepicker-wrapper">
                          <div
                            class="fm-datepicker-trigger form-control fm-form-control"
                            style="display: flex; align-items: center; gap: 8px; cursor: pointer"
                            [class.is-invalid]="!!promptStartDateError()"
                            (click)="openDatePicker($event)"
                          >
                            <img
                              class="fm-svg"
                              src="images/icons/fm-calendar.svg"
                              alt="Date Icon"
                              style="width: 16px; height: 16px; flex-shrink: 0"
                            />
                            <span [class.fm-dp-placeholder]="!promptStartDateDisplay()">
                              {{ promptStartDateDisplay() || 'Select start date' }}
                            </span>
                          </div>
                          @if (promptStartDateError()) {
                            <div class="invalid-feedback d-block">{{ promptStartDateError() }}</div>
                          }
                          @if (showDatePicker()) {
                            <div class="fm-dp-backdrop" (click)="closeDatePicker()"></div>
                            <div class="fm-dp-dropdown" [class.fm-dp-dropup]="pickerDropUp()">
                              <div class="fm-dp-header">
                                <button type="button" class="fm-dp-nav" (click)="pickerPrevMonth()">
                                  &#8249;
                                </button>
                                <span class="fm-dp-month-label">{{ pickerMonthLabel() }}</span>
                                <button type="button" class="fm-dp-nav" (click)="pickerNextMonth()">
                                  &#8250;
                                </button>
                              </div>
                              <div class="fm-dp-weekdays">
                                <span>Su</span><span>Mo</span><span>Tu</span><span>We</span
                                ><span>Th</span><span>Fr</span><span>Sa</span>
                              </div>
                              <div class="fm-dp-grid">
                                @for (cell of pickerCalendarDays(); track $index) {
                                  <button
                                    type="button"
                                    class="fm-dp-day"
                                    [class.fm-dp-today]="cell.isToday"
                                    [class.fm-dp-selected]="cell.isSelected"
                                    [class.fm-dp-empty]="!cell.isCurrentMonth"
                                    [class.fm-dp-disabled]="cell.isDisabled"
                                    [disabled]="cell.isDisabled || !cell.isCurrentMonth"
                                    (click)="selectPickerDate(cell.date)"
                                  >
                                    {{ cell.day !== null ? cell.day : '' }}
                                  </button>
                                }
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Prompt Summary -->
                <div class="fm-prompt-summary-box mt-4 mt-xl-5">
                  <div class="fm-prompt-summary-header">
                    <h4 class="fm-head-20 fm-prompt-summary-title">Prompt Summary</h4>
                  </div>
                  <div class="fm-prompt-summary-body">
                    <div class="row g-2 g-md-3 g-xl-4">
                      <!-- Row 1: 3 items -->
                      <div class="col-6 col-md-4">
                        <div class="fm-summary-item">
                          <p class="fm-summary-label">Prompt Title:</p>
                          <h6 class="fm-summary-value" [title]="promptTitle()">
                            {{ promptTitle() || '—' }}
                          </h6>
                        </div>
                      </div>
                      <div class="col-6 col-md-4">
                        <div class="fm-summary-item">
                          <p class="fm-summary-label">Category:</p>
                          <h6 class="fm-summary-value">{{ selectedCategoryName() }}</h6>
                        </div>
                      </div>
                      <div class="col-6 col-md-4">
                        <div class="fm-summary-item">
                          <p class="fm-summary-label">No. of Questions:</p>
                          <h6 class="fm-summary-value">{{ selectedQuestions().length }}</h6>
                        </div>
                      </div>
                      <!-- Row 2: 3 items -->
                      <div class="col-6 col-md-4">
                        <div class="fm-summary-item">
                          <p class="fm-summary-label">Media Type:</p>
                          <h6 class="fm-summary-value">{{ selectedMediaLabel() }}</h6>
                        </div>
                      </div>
                      <div class="col-6 col-md-4">
                        <div class="fm-summary-item">
                          <p class="fm-summary-label">Delivery Frequency:</p>
                          <h6 class="fm-summary-value">{{ selectedFrequencyName() }}</h6>
                        </div>
                      </div>
                      <div class="col-6 col-md-4">
                        <div class="fm-summary-item">
                          <p class="fm-summary-label">Cycle Duration:</p>
                          <h6 class="fm-summary-value">{{ cycleDuration() }}</h6>
                        </div>
                      </div>
                      <!-- Row 3: Invited Members (full width) -->
                      <div class="col-12">
                        <div class="fm-summary-item">
                          <p class="fm-summary-label">Invited Members:</p>
                          @if (selectedMemberNames().length === 0) {
                            <h6 class="fm-summary-value">No members selected</h6>
                          } @else {
                            <ul class="fm-summary-members-list">
                              @for (name of selectedMemberNames(); track name) {
                                <li>{{ name }}</li>
                              }
                            </ul>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fm-form-footer fm-space-between">
            <button
              type="button"
              class="fm-common-btn fm-border-btn fm-white-btn fm-btn-cancel"
              (click)="prevStep()"
            >
              <img src="images/icons/fm-arrow-left.svg" class="fm-svg" alt="Back" />
              Back
            </button>
            <button
              type="button"
              class="fm-common-btn fm-btn-next"
              [disabled]="publishing()"
              (click)="sendPrompt()"
            >
              Send Prompt
              <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Send" />
            </button>
          </div>
        </div>
      }
    </div>
    <!-- Step Form End -->
  </div>
</div>
<!-- Content Wrapper End -->

<!-- Reload Warning Modal -->
@if (showReloadWarning()) {
  <div class="fm-reload-overlay" role="dialog" aria-modal="true" aria-labelledby="reloadModalTitle">
    <div class="fm-reload-modal">
      <div class="fm-reload-modal-icon">
        <span>&#9888;</span>
      </div>
      <h3 class="fm-reload-modal-title" id="reloadModalTitle">Leave this page?</h3>
      <p class="fm-reload-modal-desc">
        Your prompt configuration will be <strong>lost</strong> if you refresh or leave. You'll need
        to start the process again.
      </p>
      <div class="fm-reload-modal-actions">
        <button type="button" class="fm-common-btn fm-primary-btn" (click)="dismissReloadWarning()">
          Stay &amp; Continue
        </button>
        <button type="button" class="fm-reload-leave-btn" (click)="confirmReload()">
          Leave anyway
        </button>
      </div>
    </div>
  </div>
}

<!-- Delete Question Confirmation Modal -->
@if (deleteConfirmId()) {
  <div class="fm-reload-overlay" role="dialog" aria-modal="true" aria-labelledby="deleteModalTitle">
    <div class="fm-reload-modal">
      <div class="fm-reload-modal-icon">
        <span>&#9888;</span>
      </div>
      <h3 class="fm-reload-modal-title" id="deleteModalTitle">Delete Question</h3>
      <p class="fm-reload-modal-desc">Are you sure you want to delete this question?</p>
      <div class="fm-reload-modal-actions">
        <button type="button" class="fm-common-btn fm-primary-btn" (click)="confirmDelete()">
          Yes, Delete
        </button>
        <button type="button" class="fm-reload-leave-btn" (click)="cancelDelete()">Cancel</button>
      </div>
    </div>
  </div>
}
